 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import COPYRIGHT from '@/components/copyright'
 import DED from '@/components/ded'
 import ACK from '@/components/ack'
 import FM1 from '@/components/fm1'
 import FM2 from '@/components/fm2'
 import FM3 from '@/components/fm3'
 import FM4 from '@/components/fm4'
 import CHAPTER1 from '@/components/chapter1'
 import CHAPTER2 from '@/components/chapter2'
 import CHAPTER3 from '@/components/chapter3'
 import CHAPTER4 from '@/components/chapter4'
 import CHAPTER5 from '@/components/chapter5'
 import CHAPTER6 from '@/components/chapter6'
 import CHAPTER7 from '@/components/chapter7'
 import CHAPTER8 from '@/components/chapter8'
 import LOVE_2 from '@/components/love_2'
 import ABOUT from '@/components/about'
 import PATTERNS from '@/components/Patterns'
 import ADPAGE from '@/components/Adpage'
 import KEY from '@/components/key'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/ded",
 			"name" : "ded",
 			"component" : DED
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/fm1",
 			"name" : "fm1",
 			"component" : FM1
 		},
 		{
 			"path" : "/fm2",
 			"name" : "fm2",
 			"component" : FM2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js